import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4efb740c&scoped=true&"
import script from "./zPayPaymentCompletedCard.js?vue&type=script&lang=js&"
export * from "./zPayPaymentCompletedCard.js?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=4efb740c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efb740c",
  null
  
)

export default component.exports